import './overlay.css';

export class HUD {
  private readonly overlay: HTMLElement;
  private readonly cookieCountEl: HTMLElement;
  private readonly nextCostEl: HTMLElement;
  private readonly trashCountEl: HTMLElement;
  private readonly trashCapEl: HTMLElement;
  private readonly hintEl: HTMLElement;
  private gameOverShown = false;

  constructor(overlayId: string = 'ui-overlay') {
    const overlay = document.getElementById(overlayId);
    if (!overlay) throw new Error(`#${overlayId} not found`);
    this.overlay = overlay;

    overlay.innerHTML = `
      <div class="hud-top-left">
        <div class="hud-pill">🍪 <span id="hud-cookie-count">0</span></div>
        <div class="hud-pill hud-cost">Next: <span id="hud-next-cost">5</span>🍪</div>
      </div>
      <div class="hud-top-right">
        <div class="hud-pill">🗑️ <span id="hud-trash-count">0</span>/<span id="hud-trash-cap">10</span></div>
      </div>
      <div class="hud-hint" id="hud-hint"></div>
    `;

    // Elements exist because we just created them above
    this.cookieCountEl = document.getElementById('hud-cookie-count')!;
    this.nextCostEl = document.getElementById('hud-next-cost')!;
    this.trashCountEl = document.getElementById('hud-trash-count')!;
    this.trashCapEl = document.getElementById('hud-trash-cap')!;
    this.hintEl = document.getElementById('hud-hint')!;
  }

  update(
    playerCookies: number,
    nextCost: number,
    trashCount: number,
    trashCapacity: number,
    canAfford: boolean,
  ): void {
    this.cookieCountEl.textContent = String(playerCookies);
    this.nextCostEl.textContent = String(nextCost);
    this.trashCountEl.textContent = String(trashCount);
    this.trashCapEl.textContent = String(trashCapacity);
    this.hintEl.textContent = canAfford
      ? `Tap to place Cookie Monster (${nextCost}🍪)`
      : `Earn ${nextCost}🍪 to place a Cookie Monster`;
    this.hintEl.style.opacity = canAfford ? '1' : '0.55';
  }

  showGameOver(totalEaten: number): void {
    if (this.gameOverShown) return;
    this.gameOverShown = true;
    this.hintEl.style.display = 'none';

    const el = document.createElement('div');
    el.className = 'hud-game-over ui-interactive';
    el.innerHTML = `
      <h1>Game Over!</h1>
      <p>The trash can is full 🗑️</p>
      <p>Cookies eaten: <strong>${totalEaten}</strong> 🍪</p>
      <button id="hud-restart">Play Again</button>
    `;
    this.overlay.appendChild(el);

    document.getElementById('hud-restart')?.addEventListener('click', () => {
      window.location.reload();
    });
  }

  dispose(): void {
    this.overlay.innerHTML = '';
  }
}
